import * as d3 from 'd3'
export default {

  methods: {
    /*
      Text_Std
      value-Unit
      value-Std
      app_wrapText
    */

    app_Text_Std(selection, idx, data, obj) {

      let numbers = selection
      .append('g')
      .attr('transform', `translate(${obj.x}, ${obj.y})`)
      .attr('cursor', 'default')

      obj.cols.forEach((d,i)=> {

        let value = d.code ? data[d.code] : d.name
        numbers
        .append('text')
        .attr('x', d.x).attr('y', d.y)
        .attr('font-size', d.tSize ? d.tSize : obj.tSize)
        .attr('fill', d.tColor ? d.tColor : obj.tColor)
        .attr('text-anchor',  d.align ? d.align : obj.align)
        .text(d.unit ? value + d.unit : value + obj.unit)
        .call(this.app_Link, data, d)

      })
    },



    app_Values_Std(selection, idx, data, obj) {

      obj.cols.forEach((d,i)=> {
        let value = 0
        if(data[d.code]) {
          value = obj.totalRef ? (data[d.code] / data[obj.totalRef]) * 100 : data[d.code]
        } 

        let numbers = selection
        .append('g')
        .attr('transform', `translate(${d.x}, ${d.y})`)
        .attr('cursor', 'default')

        numbers
        .append('text')
        .attr('id', `TITLE_${idx}_${this.localId}_${i}`)
        .attr('x',0) .attr('y', 0)
        .attr('font-size', d.tSize ? d.tSize : obj.title.tSize)
        .attr('fill', d.tColor ? d.tColor : obj.title.tColor)
        .text(d.name)

        // Sub-Title
        if(obj.sub && d.sub) {
          numbers
          .append('text')
          .attr('x', obj.sub.x) .attr('y', obj.sub.y)
          .attr('font-size', d.sSize ? d.sSize : obj.sub.sSize)
          .attr('fill', d.sColor ? d.sColor : obj.sub.sColor)
          .text(d.sub)
        }

        let pos = {x: 0, y:0, align: ''}
        switch(obj.position) {
          case 'updown':
            pos.x = 0
            pos.y = obj.space
          break
          case 'right':
            pos.x = this.getNode(`#TITLE_${idx}_${this.localId}_${i}`, 'width') + obj.space
            pos.y = 0
          break
          case 'space':
            pos.x = obj.space
            pos.y = 0
            pos.align = 'end'
          break
        }

        let delColor = d.vColor ? d.vColor : obj.value.vColor
        numbers
        .append('text')
        .attr('id', `VAL_${idx}_${this.localId}_${i}`)
        .attr('x', pos.x).attr('y',  pos.y)
        .attr('font-size', d.vSize ? d.vSize : obj.value.vSize)
        .attr('fill', obj.delta ? this.gmx_deltaValue(value) : delColor)
        .attr('text-anchor', pos.align)
        .text( ()=> {
          if(data[d.code])
            return d.unit ? this.app_toFixed(value, obj.value.fixed, d.fixed)+d.unit 
            : this.app_toFixed(value, obj.value.fixed, d.fixed) + obj.value.unit
          }
        )
        .call(this.app_Link, data, d)

        if(obj.delta) {
          let dx = obj.position == 'space' ? pos.x : pos.x + this.getNode(`#VAL_${idx}_${this.localId}_${i}`, 'width')
          numbers // Delta
          .append('path')
          .attr('transform', `translate(${dx + 2}, ${obj.delta.y}) scale(${obj.delta.scale})`)
          .attr('d', this.gmx_deltaValue(value, 'icon'))
          .attr('fill', this.gmx_deltaValue(value))
        }

      })
    },




    app_Values_Unit(selection, idx, data, obj) {

      obj.cols.forEach((d,i)=> {
        let value = 0
        value = obj.totalRef ? (data[d.code] / data[obj.totalRef]) * 100 : data[d.code]

        let numbers = selection
        .append('g')
        .attr('transform', `translate(${d.x}, ${d.y})`)
        .attr('cursor', 'default')

        numbers
        .append('text')
        .attr('y', obj.title.space)
        .attr('font-size', d.tSize ? d.tSize : obj.title.tSize)
        .attr('fill', d.tColor ? d.tColor : obj.title.tColor)
        .text(d.name)

        // Sub-Title
        if(obj.sub && d.sub) {
          numbers
          .append('text')
          .attr('x', obj.sub.x) .attr('y', obj.sub.y)
          .attr('font-size', d.sSize ? d.sSize : obj.sub.sSize)
          .attr('fill', d.sColor ? d.sColor : obj.sub.sColor)
          .text(d.sub)
        }
        
        numbers
        .append('text')
        .attr('id', `VAL_${idx}_${this.localId}_${i}`)
        .attr('font-size', d.vSize ? d.vSize : obj.value.vSize)
        .attr('fill', d.vColor ? d.vColor : obj.value.vColor)
        .text(this.app_toFixed(value, obj.value.fixed, d.fixed))
        .call(this.app_Link, data, d)

        numbers
        .append('text')
        .attr('x', this.getNode(`#VAL_${idx}_${this.localId}_${i}`, 'width') + 2)
        .attr('font-size', d.uSize ? d.uSize : obj.unit.uSize)
        .attr('fill', d.uColor ? d.uColor : obj.unit.uColor)
        .text(d.unit ? d.unit : obj.unit.unit)
      })
    },




    app_wrapText(selection, idx, data, d) {
      let items = selection

      let texts = d.wrap.code ? data[d.wrap.code] : d.wrap.texts
      items
      .append('text')
      .attr('x', d.title.x).attr('y', d.title.y)
      .attr('font-size', d.title.tSize).attr('fill', d.title.tColor)
      .text(d.title.name)

      items
      .append('g')
      .attr('id', `WRAP_GROUP_${idx}_${this.localId}`)
      .attr('transform', `translate(${d.wrap.x}, ${d.wrap.y})`)

      if(d.wrap.lineBreak == 'enter') {
        let parts = texts.split('.');
        d3.select(`#WRAP_GROUP_${idx}_${this.localId}`)
        .append('text')
        .attr('x', 0).attr('y', -d.wrap.lineheight)
        .attr('font-size', d.wrap.tSize)
        .selectAll('tspan')
        .data(parts)
        .enter()
        .append('tspan')
        .attr('x', 0).attr('dy', d.wrap.lineheight)
        .attr('fill',  d.wrap.tColor).attr('text-anchor',  d.wrap.align)
        .text((d,i) => (i != parts.length-1) ? d.trimStart() + '.' : d.trimStart())
      }
      if(d.wrap.lineBreak == 'wrap') {
        this.gmx_wrapText(
          {
            text: texts,
            wSize: d.wrap.wSize, lineHeight: d.wrap.lineheight,
            parents: `#WRAP_GROUP_${idx}_${this.localId}`, 
            tColor: d.wrap.tColor, tSize: d.wrap.tSize, align: d.wrap.align,
          },
        )
      }
    },

    

    
  }
}
